import { useEffect, useState } from "react";

// CHANGED in #30: WelcomeSheet is OPT-IN. By default disabled to
// voorkomen dat de fullscreen backdrop click-events afvangt.
// Aanzetten via:
//   localStorage.setItem("pv.welcome_enabled", "1")
//   localStorage.removeItem("pv.welcome_seen_v1")
const ENABLED_KEY = "pv.welcome_enabled";
const SEEN_KEY = "pv.welcome_seen_v1";

function isEnabled() {
  try { return localStorage.getItem(ENABLED_KEY) === "1"; } catch { return false; }
}
function isSeen() {
  try { return localStorage.getItem(SEEN_KEY) === "1"; } catch { return false; }
}
function markSeen() {
  try { localStorage.setItem(SEEN_KEY, "1"); } catch {}
}

export function WelcomeSheet() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isEnabled()) return;
    if (isSeen()) return;
    const t = setTimeout(() => setShow(true), 600);
    return () => clearTimeout(t);
  }, []);

  // ESC sluit altijd
  useEffect(() => {
    if (!show) return;
    const h = (e) => { if (e.key === "Escape") { markSeen(); setShow(false); } };
    document.addEventListener("keydown", h);
    return () => document.removeEventListener("keydown", h);
  }, [show]);

  if (!show) return null;

  const dismiss = () => { markSeen(); setShow(false); };

  return (
    <div className="ws-backdrop" onClick={dismiss}>
      <div className="ws-card" onClick={e => e.stopPropagation()} role="dialog" aria-label="Welkom">
        <button className="ws-skip" onClick={dismiss} aria-label="Sluiten">sluiten</button>
        <div className="ws-icon" aria-hidden>🌊</div>
        <h2 className="ws-title">Welkom in Portugal Verkenner</h2>
        <p className="ws-lede">
          Tap een cirkel op de kaart voor details. Het menu (☰) opent je filters,
          de trophy (🏆) toont de ranglijst.
        </p>
        <button className="ws-start" onClick={dismiss}>Aan de slag</button>
      </div>
    </div>
  );
}
